import React, { useEffect, useState, useCallback } from "react";
import UserApi from "service/userApi";
import "react-dropdown/style.css";
import LayoutV2 from "containers/LayoutV2";
import SearchForm from "./SearchForm";
import PaginationSection from "./PaginationSection";
import DanhSachMauThuChiApi from "service/DanhSachMauThuChiApi";
import MauThuChiTable from "./MauThuChiTable";
import ChiTietMauThuChi from "./ChucNang/XemChiTietMauThuChi";
import EditMauThuChi from "./ChucNang/EditMauThuChi";
import { pushNotification } from "utils/notifications";

const DanhSachMauThuChi = () => {
  const [showChiTietMauThuChi, setShowChiTietMauThuChi] = useState(false);
  const [MauThuChiDetail, setMauThuChiDetail] = useState({});
  const [showEditMauThuChi, setShowEditMauThuChi] = useState(false);
  const [MauThuChiEdit, setMauThuChiEdit] = useState({});
  const [hasPermission, setHasPermission] = useState(null);

  const [dataSearch, setDataSearch] = useState({
    sContractName: "",
    sNote: "",
    isKeyword: "False",
    pageIndex: 1,
    pageSize: 20,
  });

  const [list, setList] = useState([]);
  const [iTotal, setITotal] = useState(0);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    document.title = "Quản lý mẫu phiếu thu chi | Phần mềm quản lý cầm đồ Morman";
    const fetchPermission = async () => {
      try {
        const res = await UserApi.getAllQuyen();
        const roles = res.data.map((item) => item.ModuleCode.toLowerCase());
        setHasPermission(roles.includes("quanlymauthuchi"));
      } catch (err) {
        console.error("Lỗi load quyền:", err);
        setHasPermission(false);
      }
    };
    fetchPermission();
  }, []);


  const loadDanhSachMauThuChi = useCallback(async (dataSearch, page) => {
    try {
      setLoading(true);
      const payload = {
        ...dataSearch,
        pageIndex: page,
      };

      const res = await DanhSachMauThuChiApi.list(payload);
      // console.log("API Response:", res.data);

      setList(res.data.List || []);
      setITotal(res.data.iTotal || 0);
      setDataSearch((prev) => ({ ...prev, pageIndex: page }));

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } catch (error) {
      console.error("Lỗi load danh sách mẫu thu chi:", error);
    } finally {
      setLoading(false);
    }
  }, []);


  useEffect(() => {
    if (hasPermission) {
      loadDanhSachMauThuChi(dataSearch, 1);
    }
  }, [hasPermission]);


  const onChangeData = (field) => (event) => {
    const value = event?.target?.value ?? "";
    setDataSearch((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const onSearch = () => {
    loadDanhSachMauThuChi(dataSearch, 1);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      loadDanhSachMauThuChi(dataSearch, 1);
    }
  };


  const setModalChiTietMauThuChiShow = (MauThuChiDetail) => {
    setShowChiTietMauThuChi(true);
    setMauThuChiDetail(MauThuChiDetail);
  };

  const handlePageChange = (pageNumber) => {
    loadDanhSachMauThuChi(dataSearch, pageNumber);
  };
  const setModalEditMauThuChiShow = (MauThuChiEdit) => {
    setShowEditMauThuChi(true);
    setMauThuChiEdit(MauThuChiEdit);
  };


  if (hasPermission === null) {
    return (
      <LayoutV2>
        <div className="loader loader-default is-active"></div>
      </LayoutV2>
    );
  }
  if (hasPermission === false) {
    return (
      <LayoutV2>
        <h2 className="text-danger">
          <div className="custom-table-row">
            <div
              className="custom-table-cell text-center red"
              style={{ width: "100%" }}
            >
              Bạn không có quyền truy cập trang này!
            </div>
          </div>
        </h2>
      </LayoutV2>
    );
  }

  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <div className="breadcrumb-new">
                <div className="row">
                  <div className="col-sm-12 col-md-12 title-cd">
                    <div className="media-home align-center-home">
                      <div className="row header">
                        <img
                          src="/app-assets/images/icon-hop-dong-cho-duyet.png"
                          alt="logo"
                        />
                        <h1 className="text-info-home">Quản lý mẫu thu chi</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card border-light mb-3 hidden-mobile-main show-table-main card-v2"
                style={{}}
              >
                <div className="card-body card-body-v2">
                  <SearchForm
                    dataSearch={dataSearch}
                    onChangeData={onChangeData}
                    onSearch={onSearch}
                    handleKeyDown={handleKeyDown}
                  />
                </div>
              </div>

              <div
                className="card border-light mb-3 card-v2"
                style={{ marginTop: "-35px" }}
              >
                <div className="card-body card-body-v2" style={{ userSelect: "text" }}>
                  <MauThuChiTable
                    list={list}
                    pageIndex={dataSearch.pageIndex}
                    pageSize={dataSearch.pageSize}
                    onShowDetail={setModalChiTietMauThuChiShow}
                    iTotal={iTotal}
                    onEdit={setModalEditMauThuChiShow}
                  />

                </div>
                <div
                  className="card border-light mb-3 card-v2"
                  style={{
                    marginLeft: "15px",
                    marginRight: "15px",
                    marginTop: "-15px",
                  }}
                >
                  <div className="card-body card-body-v2">
                    <PaginationSection
                      iTotal={iTotal}
                      dataSearch={dataSearch}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ChiTietMauThuChi
          chitietMauThuChi={{ showModalMauThuChi: showChiTietMauThuChi }}
          showModalChiTietMauThuChi={() => setShowChiTietMauThuChi(false)}
          data={{
            ContractId: MauThuChiDetail?.ContractId,
            ContractName: MauThuChiDetail?.ContractName,
            ContractContent: MauThuChiDetail?.ContractContent,
            Keyword: MauThuChiDetail?.Keyword,
          }}
        />
        <EditMauThuChi
          show={showEditMauThuChi}
          onClose={() => setShowEditMauThuChi(false)}
          data={{
            ContractId: MauThuChiEdit?.ContractId,
            ContractName: MauThuChiEdit?.ContractName,
            ContractContent: MauThuChiEdit?.ContractContent,
            Keyword: MauThuChiEdit?.Keyword,
          }}
          onSave={async (updatedData) => {
            try {
              await DanhSachMauThuChiApi.update(updatedData);
              loadDanhSachMauThuChi(dataSearch,1); // reload danh sách
              setShowEditMauThuChi(false);
              pushNotification("Cập nhật mẫu thu chi thành công!", "success", "TOP_CENTER", 1000);
              return true;
            } catch (err) {
              console.error("Lỗi khi lưu:", err);
              throw err; // báo cho EditMauThuChi biết lỗi
            }
          }}
        />

      </div>
    </LayoutV2>
  );
};

export default DanhSachMauThuChi;
